var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.results)?_c('Card',[_c('p',{attrs:{"slot":"title"},domProps:{"innerHTML":_vm._s(_vm.results.subject)},slot:"title"}),_c('p',{staticClass:"c-message-templates__preview",domProps:{"innerHTML":_vm._s(_vm.results.bodyHtml)}})]):_c('loading-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }